<template>
  <div v-if="newsList && newsList.length">
    <NewsCard class="news-list__main-card"
      :news="newsList[0]"
      :is-main="true" />

    <div class="news-list-container">

      <ul class="news-list">
        <template v-for="(newsItem, index) in newsList"
          :key="index">
          <li class="news-list__item">
            <NewsCard :news="newsItem"
              :card-link="cardLink" />
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import NewsCard from "@/components/NewsCard.vue";

export default {
  name: "NewsList",
  components: {
    NewsCard,
  },

  props: {
    newsList: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      cardLink: false,
    };
  },

  mounted() {
    this.onCardLink();
  },

  methods: {
    onCardLink() {
      const media = window.matchMedia("(max-width:1279px)");
      const listener = (event) => (this.cardLink = event.matches);
      listener(media);

      media.addEventListener("change", listener);
    },
  },
};
</script>

<style lang="scss" scoped>
.news-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 9px;

  @include media($max-width: 1920px) {
    grid-row-gap: calc(32 / 1920 * 100vw);
  }

  @include laptop {
    grid-template: 1fr / repeat(4, 1fr);
    grid-column-gap: calc(21 / 1279 * 100vw);

    .news-page & {
      grid-template: 1fr / repeat(3, 1fr);
    }
  }

  @include tablet {
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: calc(21 / 1023 * 100vw);

    .news-page & {
      grid-template: 1fr / repeat(2, 1fr);
    }
  }

  @include phone {
    grid-template: 1fr / 1fr !important;
    grid-row-gap: 20px;
  }

  &-container {
    @extend %container;
  }

  &__item {

    &:last-child {
      @include tablet {
        .news-section & {
          display: none;
        }
      }
    }
  }

  &__main-card {
    @include phone {
      margin-bottom: 30px;
    }
  }
}
</style>
